import { Text } from '@chakra-ui/react';
import theme from '../theme.js';

const Header = ({ pageHeader }) => {
  return (
    <div
      style={{
        height: '75px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: theme.colors.neutralLight,
      }}
    >
      <Text fontSize="2xl" fontWeight="bold" margin={'25'}>
        {pageHeader}
      </Text>
    </div>
  );
};

export default Header;
